import { waitForElementInViewOnce } from './functions';

interface HighLightConstructorModel {
  element: HTMLElement;
}

class HighLightClass {
  highLightElement: HTMLElement;

  constructor({ element }: HighLightConstructorModel) {
    this.highLightElement = element;
  }

  init() {
    this.addAnimationHeading();
  }

  addAnimationHeading() {
    const stats = this.highLightElement.querySelector<HTMLElement>('.kf-o-highlights__stats');
    const icon = this.highLightElement.querySelector<HTMLElement>('.kf-o-highlights__icon');

    if (stats) {
      waitForElementInViewOnce(stats)
        .then(() => {
          this.highLightElement.classList.add('run-animation');
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (icon) {
      waitForElementInViewOnce(icon)
        .then(() => {
          this.highLightElement.classList.add('run-animation');
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
}

export { HighLightClass };
